var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenderDefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5026 26.5669V28.5025C26.5026 28.7048 26.3807 28.8872 26.1938 28.9647C26.0069 29.0421 25.7918 28.9993 25.6487 28.8562L23.3594 26.5669",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0039 17.499H26.5077C27.887 17.499 29.0052 18.6171 29.0052 19.9965V24.0694C29.0052 25.4488 27.887 26.5669 26.5077 26.5669V26.5669",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3639 26.5669H20.4975C19.1182 26.5669 18 25.4488 18 24.0694V23.0013",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7045 20L14.351 22.3535C14.208 22.4966 13.9928 22.5394 13.8059 22.462C13.619 22.3845 13.4971 22.2021 13.4971 21.9998V20H13.4936C12.8312 20 12.196 19.7369 11.7276 19.2685C11.2592 18.8001 10.9961 18.1649 10.9961 17.5025V13.4937C10.9961 12.1144 12.1143 10.9962 13.4936 10.9962H20.5036C21.8829 10.9962 23.0011 12.1144 23.0011 13.4937V17.5025C23.0011 18.1649 22.738 18.8001 22.2696 19.2685C21.8012 19.7369 21.166 20 20.5036 20H16.7045Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderDefine);
export default __webpack_public_path__ + "static/media/tenderDefine.98821cdf1bb76a24b1b884443245596f.svg";
export { ForwardRef as ReactComponent };